/**
 * <ContinueWithSocialPulse /> — the sister-app "Continue with SocialPulse"
 * SSO button. Renders NOTHING on SocialPulse itself (env vars unset), so
 * it's safe to drop into any brand-neutral login screen.
 */
import { useState } from "react";
import { toast } from "sonner";
import { getSocialPulseSsoConfig, startSocialPulseLogin } from "@/lib/socialpulseOidc";

// Simple, brand-neutral SVG glyph so we don't ship yet another external
// image. Colour comes from the surrounding button.
function SocialPulseGlyph({ className }) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" className={className} aria-hidden>
      <path
        fill="currentColor"
        d="M4 12a8 8 0 0 1 16 0 8 8 0 0 1-16 0Zm2.1 0a5.9 5.9 0 1 0 11.8 0 5.9 5.9 0 0 0-11.8 0Zm3.2-.9 1.4 3 1.5-5.6 1.5 5.6 1.4-3H16v1.7h-1l-2 3.9-1-3.9-1 3.9-2-3.9H8v-1.7h1.3Z"
      />
    </svg>
  );
}

export default function ContinueWithSocialPulse({ returnTo, className = "", label = "Continue with SocialPulse" }) {
  const cfg = getSocialPulseSsoConfig();
  const [busy, setBusy] = useState(false);
  if (!cfg) return null; // We ARE SocialPulse — hide the button.

  const onClick = async () => {
    setBusy(true);
    try {
      await startSocialPulseLogin({ returnTo });
    } catch (e) {
      setBusy(false);
      toast.error(e.message || "Could not start SocialPulse sign-in.");
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid="continue-with-socialpulse-btn"
      className={
        "w-full inline-flex items-center justify-center gap-2.5 px-4 py-2.5 rounded-full text-sm font-semibold border transition-colors hover:bg-black/5 disabled:opacity-60 " +
        className
      }
      style={{ borderColor: "var(--wofy-border)", color: "var(--wofy-text)" }}
    >
      <SocialPulseGlyph className="opacity-90" />
      {busy ? "Redirecting…" : label}
    </button>
  );
}
